/**
 * Custom hook untuk mengambil detail agent berdasarkan ID
 * 
 * API Endpoint: GET `/api/agent/:id`
 * API Version: 3.0
 * 
 * @param {string} id - ID agent
 * @returns {object} - Return value berupa object dengan key `data`, `isLoading`, dan `error`.
 * @example
 * const { data, isLoading, error } = useShowBank({ id: '1' });
 */


import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { AgentResponseSchema } from "../response/ShowAgentResponse";

interface ShowAgentProps {
    id?: string;
}

const useShowAgent = ({ id }: ShowAgentProps) => {
    return useQuery({
        queryKey: ['agents', id],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v3/agent/${id}`);

                // Validasi response
                const validationResult = AgentResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid agent data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch agent`, error);
                throw error;
            }
        },
        enabled: !!id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useShowAgent;